import { Component, ViewChild, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { KngButtonState } from 'kinetic-angular';
import { KngUploadFileComponent, ErrorMessageHeading, ErrorMessageSubHeading } from 'projects/kinetic-angular/src/lib/components';
import { InviteUsersService } from './invite-users.service';
import { InviteUserState } from './definitions';
import { ApplicationPath } from '../../services/shared/shared-enums';
import { SharedService } from '../../services/shared/shared.service';
import { Router } from '@angular/router';
import { uploadLimitText, uploadLimit } from '../../services/shared/shared-constants';
import * as XLSX from 'xlsx';

@Component({
	selector: 'tmhna-portal-invite-users',
	templateUrl: './invite-users.component.html',
	styleUrls: ['./invite-users.component.scss']
})

export class InviteUsersComponent implements  OnInit
{

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	fileToUpload: File | any = null;
	@Input() isBulkUsers: boolean = false;
	@ViewChild(KngUploadFileComponent, { static: false }) fileUploadComponent: | KngUploadFileComponent | undefined;
	fileUploadLoader!: boolean;
	uploadLimitText:string = uploadLimitText;
	uploadLimit:string = uploadLimit;
	@Output() setIsDirty: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Input() set state(value: InviteUserState)
	{
		this.service.updateState(value);
	}
	get state(): InviteUserState
	{
		return this.service.state;
	}
	get isRaymond(): boolean
	{
		return this.service.isRaymond;
	}
	get downloadButtonState(): KngButtonState
	{
		return this.service.downloadButtonState;
	}
	get sendInviteButtonState(): KngButtonState
	{
		return this.service.sendInviteButtonState;
	}
	get linkButtonState():KngButtonState
	{
		return this.service.linkButtonState;
	}
	get submitButtonState(): KngButtonState
	{
		return this.service.submitButtonState;
	}
	get cancelButtonState(): KngButtonState
	{
		return this.service.cancelButtonState;
	}
	constructor(public service: InviteUsersService, private readonly sharedService:SharedService, private readonly router: Router)
	{}

	ngOnInit(): void
    	{
		this.service.submitButtonState.disabled = true;
		this.service.sendInviteButtonState.disabled = true;
		
    	this.service.getInviteUsersLabelState(this.isBulkUsers);
		this.service.castFileUploadStatus.subscribe((fileUploadStatus : string) => 
		{
			if(fileUploadStatus !== '' || fileUploadStatus !== undefined)
			{
				this.replaceFileEventEmitter();
				this.fileUploadLoader = false;
			}
		});
		this.resetUploadForm();
	}
	resetUploadForm()
	{
		if(this.fileUploadComponent)
			this.fileUploadComponent.files = [];
		this.state.responseMessage = '';
		this.service.submitButtonState.disabled = true;
		this.state.messageTitle = '';
		this.state.messageDescription = '';
		this.state.link.downloadButton = '';
	}
	
	crossCta() 
	{
		this.service.displayFlag = true;
	}

	downloadLocationTemplate()
	{
		this.service.getInviteUserLocationDownload(this.isBulkUsers);
	}
	linkDownloadTemplate()
	{
		this.service.linkXLXSDownload(this.isBulkUsers);
	}
	submitLocationTemplate()
	{
		this.fileUploadLoader = true;
		this.service.getInviteUserSubmitButton(this.fileToUpload, this.isBulkUsers);
	}
	uploadFileServerValidation(item: File)
	{
		this.service.checkServerValidationUploadFile(item, this.isBulkUsers);
	}
	replaceFileEventEmitter()
	{
		if(this.fileUploadComponent)
			this.fileUploadComponent.files = [];
	}
	fileValidationCheck(item: File)
	{
		const fileNameArr = item.name.split('.');
    	const extension = fileNameArr.pop();
		this.setIsDirty.emit(true);
    	const fileName = fileNameArr.join('.');
		if(fileNameArr.length !== 1 || fileName.trim().length === 0 || fileName.includes('/') || /\\/.exec(fileName) || extension !=='xlsx')
		{
			this.service.uploadFileState.errorHeading = ErrorMessageHeading.uploadFailed;
			this.service.uploadFileState.errorSubHeading = ErrorMessageSubHeading.wrongFormat;
			this.service.sendInviteButtonState.disabled = true;
			this.service.submitButtonState.disabled = true;
			this.emptyUploadFilesArray();
		}
		else
		{
			this.checkOtherFileValidation(item);
		}
	}
	checkOtherFileValidation(item: File)
	{
		const fileSize = Math.round((item.size / 1024));
		if(fileSize > 102400) 
		{
			this.service.uploadFileState.errorHeading = ErrorMessageHeading.sizeExceed;
			this.service.uploadFileState.errorSubHeading = ErrorMessageSubHeading.incorrectSize;
			this.emptyUploadFilesArray();
			this.service.submitButtonState.disabled = true;
			this.service.sendInviteButtonState.disabled = true;
			return;
		}
		else
		{
			if(this.fileUploadComponent)
				this.fileUploadComponent.files[0] = item;
			this.service.submitButtonState.disabled = false;
			this.service.sendInviteButtonState.disabled = false;
			this.service.uploadFileState.isSuccessClient = true;
			this.service.uploadFileState.isSuccessServer = false;
			this.fileToUpload = this.fileUploadComponent?.files[0];
		}
		if(fileSize < 102400)
		{
			var file = item;
			var reader = new FileReader();
			reader.onload = (e) => 
			{
				this.service.uploadFileState.fileUploadLoader = true;
				const target = e.target as FileReader;
				const data = new Uint8Array(target.result as ArrayBuffer || []);
				const workbook = XLSX.read(data, { type: 'array' });
				const firstSheetName = workbook.SheetNames[0];
				const worksheet = workbook.Sheets[firstSheetName];
				const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as unknown[][];

				if (jsonData.length === 0 || (jsonData.length === 1 && jsonData[0].length === 0)) 
				{
					this.service.uploadFileState.errorHeading = ErrorMessageHeading.emptyFile;
					this.service.uploadFileState.errorSubHeading = ErrorMessageSubHeading.emptyFile;
					this.emptyUploadFilesArray();
					this.service.submitButtonState.disabled = true;
					this.service.sendInviteButtonState.disabled = true;
					this.service.uploadFileState.fileUploadLoader = false;
					return;
				} 
				else
				{
					this.service.uploadFileState.fileUploadLoader = false;
					return;
				}
			};
			reader.readAsArrayBuffer(file);
		}
	}
	emptyUploadFilesArray()
	{
		this.service.uploadFileState.isError = true;
		this.service.uploadFileState.isSuccessClient = false;
		this.service.uploadFileState.isSuccessServer = false;
		if(this.fileUploadComponent)
			this.fileUploadComponent.files = [];
	}
	goBackToUserManagement(): void
	{
		this.sharedService.navigateMethod(this.router, ApplicationPath.userManagement);
	}
}

